module.exports = function SharedWorker_fn() {
  return new SharedWorker(__webpack_public_path__ + "echo-worker.worker.bd9593d4c1a00200cdf1.js");
}
